import React from 'react';
import { CircularProgress, Tabs, Tab, Typography, Badge } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const styles = makeStyles()((theme) => {
    return {
        tabWrapper: {
            alignItems: 'flex-start',
        },
        container: {
            borderRight: '1px solid #dadada',
        },
    };
});

const Categories = ({
    list,
    loading,
    onChange,
    orientation,
    initiallyActive,
    ...props
}) => {
    const [activeTab, setActiveTab] = React.useState(initiallyActive);
    const { classes } = styles();

    if (loading) {
        return <CircularProgress />;
    }

    const handleTabChange = (event, value) => {
        setActiveTab(value);
        onChange(value);
    };

    return list && list.length ? (
        <Tabs
            value={activeTab}
            orientation={orientation || 'vertical'}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleTabChange}
            variant="scrollable"
        >
            {list.map((item, idx) => (
                <Tab
                    key={`resource-tab-${idx}`}
                    value={item.id}
                    label={
                        item.count ? (
                            <Typography variant="caption">
                                {item.label}{' '}
                                <Badge
                                    style={{ marginLeft: 20 }}
                                    color="primary"
                                    badgeContent={item.count}
                                />
                            </Typography>
                        ) : (
                            <Typography variant="caption">
                                {item.label}
                            </Typography>
                        )
                    }
                    alignItems="flex-start"
                    disabled={item.disabled}
                    classes={
                        orientation !== 'horizontal' && {
                            // @ts-ignore
                            wrapper: classes.tabWrapper,
                        }
                    }
                />
            ))}
        </Tabs>
    ) : (
        <Typography>There are no items available</Typography>
    );
};

export default Categories;
